import Vue from "vue";
import App from "./App.vue";
import router from "./router";

// import Graph01 from "./components/Graph01";
import Header from "./components/MainHeader.vue";
import Footer from "./components/MainFooter.vue";
import BreadCrumbs from "./components/BreadCrumbs.vue";

Vue.config.productionTip = false;

// Vue.component('Graph01',Graph01);
Vue.component('Header',Header);
Vue.component('Footer',Footer);
Vue.component('BreadCrumbs',BreadCrumbs);

// router.beforeEach( (to,from,next)=> {
//   let ele = document.getElementsByClassName('subnav-ul');
//   ele.forEach(function(item){
//     item.style.display = 'none';
//   });
//   next();
// });

router.afterEach( ()=> {
  window.scrollTo({
    top: 0,
  });
});

// router.beforeEach( (to,from,next)=> {
//   window.scrollTo({
//     top: 0,
//   });
//   next();
// });

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
